__turbopack_context__.v({
  "localHeroBadge": "LocalHeroBadge-module__4Z5RBa__localHeroBadge",
  "localHeroIcon": "LocalHeroBadge-module__4Z5RBa__localHeroIcon",
});
